import { render, staticRenderFns } from "./ThreatEventsTable.vue?vue&type=template&id=80417be8&"
import script from "./ThreatEventsTable.vue?vue&type=script&lang=js&"
export * from "./ThreatEventsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports